package presentation.screens.business.employee.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import feature.employee.model.Employee
import theme.ThemeColor

@Composable
fun EmployeeCard(employee: Employee, onClick: (Employee) -> Unit = {}) {
    ElevatedCard(
        modifier = Modifier
            .height(140.dp)
            .padding(8.dp)
            .clip(RoundedCornerShape(10.dp))
            .background(ThemeColor.shared().cardBackground, shape = RoundedCornerShape(10.dp))
            .clickable {
                onClick(employee)
            },
        colors = CardDefaults.cardColors(
            containerColor = ThemeColor.shared().cardBackground,
            contentColor = Color.Black,
            disabledContainerColor = ThemeColor.shared().cardBackground
        ),

        ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .padding(start = 8.dp, end = 8.dp),

            ) {
            Row(
                modifier = Modifier
                    .height(30.dp).fillMaxWidth()
            ) {
                Text(
                    text = "Name : ",
                )
                Text(
                    text = employee.Name ?: "",
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier
                        .height(85.dp).fillMaxWidth(),
                    textAlign = TextAlign.Start,
                    color = ThemeColor.shared().PrimaryColor
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(30.dp)
            ) {
                Text(
                    text = "Mobile  :    ",
                    textAlign = TextAlign.Start
                )
                Text(
                    text = (employee.DialCode ?: "") + (employee.MobileNumber ?: ""),
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(30.dp),
                    textAlign = TextAlign.Start,
                    color = ThemeColor.shared().PrimaryColor
                )
            }
        }
    }
}